const accessLevelDict = {
  0: 'NONE',
  1: 'READ',
  2: 'CREATE',
  3: 'UPDATE',
  4: 'DELETE',
  5: 'ADMIN'
} as const

export const getAccessLevelName = (accessLevel: AccessLevel) => {
  return accessLevelDict[accessLevel]
}

enum AccessLevel {
  NONE = '0',
  READ = '1',
  CREATE = '2',
  UPDATE = '3',
  DELETE = '4',
  ADMIN = '5'
}

export default AccessLevel
